/* eslint-disable max-len */
import { DestroyRef, inject, Injectable } from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { QueryRef } from '@apollo/client';
import { AuthService } from '@s2a/core';
import { Apollo } from 'apollo-angular';
import { Subject } from 'rxjs';
import { ExternalSystemStatusItem } from '../models/external-system.status.model';
import { onPublisExternalDeviceStatusSubscription } from '../graphql/subscriptions/external-system-status.subscription';
import { GraphQLHistoryService } from './graphQl-history.service';
import { getExternalDeviceStatus } from '../graphql/queries/external-system-status.queries';

@Injectable({
  providedIn: 'root',
})
export class ExternalSystemStatusService {
  private _destroyRef: DestroyRef;

  externalSystemQueryRef: QueryRef<any, any>;
  externalSystemStatus$ = new Subject<ExternalSystemStatusItem | ExternalSystemStatusItem[]>();

  constructor(
    private authService: AuthService,
    private apolloClient: Apollo,
    private graphQLHistoryService: GraphQLHistoryService,
  ) {
    this._destroyRef = inject(DestroyRef);
    this.establishGetExternalSystemStatus();
  }

  /**
   * The method is used to retrieve latest external system status for the logged in account
   */
  private retrieveLatestExternalSystemStatus(): void {
    this.apolloClient
      .subscribe({
        query: getExternalDeviceStatus,
      })
      .subscribe((responseData: any) => {
        const data: ExternalSystemStatusItem = responseData.data.getExternalSystemStatus;
        this.externalSystemStatus$.next(data);
      });
  }

  /**
   * The method is used to subscribe to the external device status using graph ql end point
   */
  private subscribeToExternalDeviceStatus(): void {
    const accountId = this.authService.user?.account;
    this.apolloClient
      .subscribe({
        query: onPublisExternalDeviceStatusSubscription,
        variables: { accountId },
      })
      .subscribe((responseData: any) => {
        const data: ExternalSystemStatusItem = responseData.data.onCreateExternalSystemStatusItem;
        this.externalSystemStatus$.next(data);
      });
  }

  /**
   * Kick off function to establish web socket connection with Graph Ql End point when the client is ready
   */
  private establishGetExternalSystemStatus() {
    this.graphQLHistoryService.client$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.subscribeToExternalDeviceStatus();
      this.retrieveLatestExternalSystemStatus();
    });
  }
}
